import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
export const GinStepHeaderContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: space-between;

  ${media.mobile `
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  `}
`;
export const GinStepDatesRow = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: fit-content;

  ${media.mobile `
    flex-direction: column;
    gap: 0px;
    margin-top: 4px;
  `}
`;
export const DatesSegment = styled.div `
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: fit-content;
  ${(p) => p.$withSeparator
    ? `
  border-left: 1px solid ${p.theme.colors.grey_3};
  padding-left: ${p.theme.spacing.sm}px;
  `
    : ''}

  ${media.mobile `
    border-left: none;
    padding-left: 0;
  `}
`;
export const StepOwnerRoleButton = styled.div `
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  width: 32px;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  max-width: 40px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
export const GinStepHeaderOwnerAvatarButton = styled.div `
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 40px;
`;
export const GinStepHeaderContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
  align-items: flex-start;
`;
export const GinStepHeaderBody = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  padding-right: ${({ theme }) => theme.spacing.sm}px;
  max-height: 13px;
  width: fit-content;
  height: fit-content;
  line-height: 1;
`;
export const GinStepHeaderSection = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  padding-top: 2px;
  max-height: 13px;
  width: fit-content;
  height: fit-content;
  line-height: 1;
`;
export const GinStepHeaderRow = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xs}px;
  flex: 1;
`;
export const GinStepHeaderActions = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  flex: 0 0 auto;
  max-width: 40px;
  display: flex;
  justify-content: flex-end;
`;
export const GinStepHeaderSection2 = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
